export const BASE_COLOR = "#008B52"
export const dateFormatList = ["DD/MM/YYYY"];
export const regrexAtLeast = /^(?=.*[a-zA-Z])(?=.*\d).+$/    
export const LOGIN_PATH = "/login"
